import Headroom from "headroom.js"

/**
 * GlobalHeader component.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new scroll CTA.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
    this.mainNav = this.element.querySelector('[data-component="main-nav"]')
    this.navItems = this.mainNav.queryAll('ul > li.menu-item-has-children')
    this.aboutNavItems = this.mainNav.queryAll('li.about-menu .sub-menu-wrapper ul li a')

    var headroom  = new Headroom(this.element)

    this.navToggle.addEventListener('click', e => {
      this.element.classList.toggle('nav-open')
      this.navToggle.classList.toggle('is-active')
    })

    this.navItems.forEach(element => {
      const toggle = element.querySelector('.arrow')
      toggle.addEventListener('click', (e) => {
        var index = this.navItems.indexOf(element)
        if (element.classList.contains('open')) {
          this.close(this.navItems)
          e.preventDefault()
        } else {
          e.preventDefault()
          this.close(this.navItems)
          this.open(element, index)
        }
      })
    })

    if (document.body.classList.contains('page-template-page-about')) {
      this.aboutNavItems.forEach(element => {
        element.addEventListener('click', (e) => {
          this.element.classList.remove('nav-open')
          this.navToggle.classList.remove('is-active')
        })
      })
    }

    headroom.init()

  }

  /**
  * Closes expanded state.
  */
  close (navItems) {
    this.navItems.forEach(element => {
      element.classList.remove('open')
    })
  }

  /**
  * Opens expanded state.
  */
  open (element, index) {
    element.classList.add('open')
  }

}



// WEBPACK FOOTER //
// ./components/global-header/index.js